var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFacebookFillCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1001 0C7.9874 0 0.600098 7.3873 0.600098 16.5C0.600098 25.6127 7.9874 33 17.1001 33C26.2128 33 33.6001 25.6127 33.6001 16.5C33.6001 7.3873 26.2128 0 17.1001 0ZM18.8203 17.2248V26.2016H15.1061V17.2251H13.2505V14.1316H15.1061V12.2743C15.1061 9.75067 16.1539 8.25 19.1308 8.25H21.6092V11.3438H20.06C18.9012 11.3438 18.8245 11.7761 18.8245 12.583L18.8203 14.1313H21.6267L21.2983 17.2248H18.8203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebookFillCircle);
export default __webpack_public_path__ + "static/media/ic-facebook-fill-circle.0e83534b8cca150ce84a8a93d7e76d72.svg";
export { ForwardRef as ReactComponent };